import { authService } from '../services/AuthService';

/**
 * Obtiene el rol del usuario a partir de la sesión actual.
 * @returns {string|null} El rol del usuario o null si no hay sesión.
 */
export function getUserRoleFromToken() {
    const sessionData = authService.getSessionData();
    return sessionData?.role || null;
}

export function getShopIdFromToken() {
    const sessionData = authService.getSessionData();
    return sessionData?.shopId || null;
}

export function getShopBranchIdFromToken() {
    const sessionData = authService.getSessionData();
    return sessionData?.shopBranchId || null;
}

export function getUserIdFromToken() {
    const sessionData = authService.getSessionData();
    return sessionData?.user?.id || null;
}

export function getIdentificationNumberFromToken() {
    const sessionData = authService.getSessionData();
    return sessionData?.user?.identificationNumber || null;
}

/**
 * Verifica si hay una sesión válida.
 * @returns {boolean} True si hay sesión, false si no.
 */
export function isTokenExpired() {
    const sessionData = authService.getSessionData();
    return !sessionData || !sessionData.authenticated;
}
